export const DEEPGRAM_AUTH_SUBPROTOCOL = 'token'

export const WEBSOCKET_NORMAL_CLOSE_CODE = 1000

// Deepgram surfaces quota/billing problems through these close codes.
export const DEEPGRAM_QUOTA_CLOSE_CODES = new Set([1008, 4029])

// Fallback signal when close codes alone are ambiguous.
export const DEEPGRAM_QUOTA_REASON_PATTERN =
  /credit|quota|insufficient|payment|billing/i

// Numeric WHATWG WebSocket readyState values, inlined so importing this module
// doesn't reach for the global `WebSocket` at eval time (e.g. under Jest node).
export const WebSocketReadyState = {
  Closed: 3,
  Closing: 2,
  Connecting: 0,
  Open: 1,
}

export const DeepgramWebSocketError = {
  ConfigError: 'deepgram-config-error',
  ConnectionError: 'deepgram-connection-error',
  QuotaError: 'deepgram-quota-error',
  ServiceError: 'deepgram-service-error',
}
